export { default as TermsAcceptModal } from './TermsAcceptModal';
